import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { JobService } from 'src/app/services/job.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Kind } from 'src/app/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manage-job-package',
  templateUrl: './manage-job-package.component.html',
  styleUrls: ['./manage-job-package.component.scss']
})
export class ManageJobPackageComponent implements OnInit {
  constructor(private jobService: JobService, private spinner: SpinnerService) { }
  Object = Object;
  Kind = Kind;

  packages: any[];
  selected: any = {};
  image: File;
  preview: string | ArrayBuffer;
  imageUrl = environment.app.assetsUrl + 'package-images/';

  @ViewChild('packageModal') packageModal: NgxSmartModalComponent;
  async ngOnInit() {
    await this.load();
  }

  loadImage(image: File) {
    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = () => this.preview = reader.result;
    this.image = image;
  }

  private async load() {
    this.spinner.show();
    this.packages = await this.jobService.allPackages();
    this.spinner.hide();
  }

  openModal(_package?: any) {
    this.selected = Object.assign({}, _package || { IsCpc: true, MinBudget: 0, MaxBudget: 700000, Prices: [] });
    this.packageModal.open();
  }

  async delete(id: string) {
    this.spinner.show('action');
    await this.jobService.deletePackage(id);
    this.spinner.hide('action');
    await this.load();
  }

  async save() {
    this.spinner.show('action');
    await this.jobService.savePackage(this.selected, this.image);
    delete this.image;
    delete this.preview;
    this.spinner.hide('action');
    this.packageModal.close();
    await this.load();
  }

  toggleKind(kind: Kind) {
    if(!this.selected.Kinds) this.selected.Kinds = [];
    var i = this.selected.Kinds.indexOf(kind);
    if (i < 0) this.selected.Kinds.push(kind);
    else this.selected.Kinds.splice(i, 1);
  }
}
